<ng-container *ngIf="modalPortal$ | async as modalPortal">
  <ng-template [cdkPortalOutlet]="modalPortal"></ng-template>
</ng-container>
